
<stat-item
  :label="statObj.label"
  :value="statObj.displayValue"
  :success="statObj.success"
  :error="statObj.error"
/>
